import {
  IDocumentEletronicSignature,
  ITermDataDraft
} from "../../interfaces/ITerm.interface";

import { Account } from "@/components/Contracts/contract.interface";
import { SignatureResendSection } from "@/components/Shared/SignatureResendSection";

interface ISignaturesCard {
  documentId: number;
  eletronicSignature?: IDocumentEletronicSignature;
  businessUnitId: number;
  account?: Account;
  termDataDraft?: ITermDataDraft;
  refetchData: () => Promise<void>;
  canUpdateSignatureMethod: boolean;
}

export const SignaturesCard = ({
  documentId,
  eletronicSignature: electronicSignature,
  businessUnitId,
  account,
  termDataDraft,
  refetchData,
  canUpdateSignatureMethod
}: ISignaturesCard) => {
  const apiConfig = {
    resendSignatureEndpoint: `terms/${documentId}/resend-signatures`,
    updateSignatureEndpoint: `terms/signature-method/${documentId}`
  };

  return (
    <SignatureResendSection
      electronicSignature={electronicSignature}
      businessUnitId={businessUnitId}
      account={account}
      refetchData={refetchData}
      apiConfig={apiConfig}
      cardProps={{ height: "inherit" }}
      termDataDraft={termDataDraft}
      canUpdateSignatureMethod={canUpdateSignatureMethod}
    />
  );
};
